import '../dist/contact-profile-v1.css'
import '../blueprints/contact-profile-v1.ts'
